<template>
  <div>
    <div v-if="fill_info == '' && form.fields.length > 0">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
        </div>
        <div class="col-xs-12">
          <h5 style="margin-top: 0px;" class="form-block-title">
            Alapadatok
          </h5>
        </div>
        <div class="col-xs-6">
          <div class="form-group">
            <label class="form-label">Név</label>
            <input disabled="disabled" type="text" name="nev" class="form-control" v-model="form.hallgato_alapadatok.nev"/>
          </div>
          <div class="form-group">
            <label class="form-label">Neptun azonosító</label>
            <input disabled="disabled" type="text" name="neptunkod" class="form-control" v-model="form.hallgato_alapadatok.neptunkod"/>
          </div>
          <div class="form-group">
            <label class="form-label">Szak</label>
            <p class="form-group-info">(A szak képesítési követelményeit meghatározó Korm. rendelet szerinti megnevezés).</p>
            <input disabled="disabled" type="text" name="szak" class="form-control" v-model="form.hallgato_alapadatok.szak"/>
          </div>
          <div class="form-group">
            <label class="form-label">Teljesített aktív félévek száma</label>
            <input disabled="disabled" type="text" name="aktiv_felevek_szama" class="form-control" v-model="form.hallgato_alapadatok.aktiv_felevek_szama"/>
          </div>
        </div>
        <div class="col-xs-6">
          <div class="form-group">
            <label class="form-label">Születési hely, idő</label>
            <input disabled="disabled" type="text" name="szulhelyido" class="form-control" v-model="form.hallgato_alapadatok.szulhelyido"/>
          </div>
          <div class="form-group">
            <label class="form-label">Kar</label>
            <input disabled="disabled" type="text" name="kar" class="form-control" v-model="form.hallgato_alapadatok.kar"/>
          </div>
          <div class="form-group">
            <label class="form-label">Képzés szintje</label>
            <p class="form-group-info">&nbsp;</p>
            <input disabled="disabled" type="text" name="kepzes_szint" class="form-control" v-model="form.hallgato_alapadatok.kepzes_szint"/>
          </div>
          <div class="form-group">
            <label class="form-label">Megszerzett kreditpontok száma</label>
            <input disabled="disabled" type="text" name="kar" class="form-control" v-model="form.hallgato_alapadatok.kreditek_szama"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h5 class="form-block-title">
            Tanulmányok
          </h5>
          <comboboxV2 v-on:onChange="(index) => { szakValt(index, true, true); }" label="Szakok" id="szak_id" name="szak_id" :options="szak_combo_opts" v-model="szak_combo_index"/>
          <h6>Az utolsó két lezárt félév átlaga</h6>
        </div>
        <div class="col-xs-3">
          <div class="form-group">
            <label class="form-label">I. félév</label>
            <input disabled="disabled" type="text" name="tanulm_ef" class="form-control" v-model="form.hallgato_atlagok.felev1"/>
          </div>
        </div>
        <div class="col-xs-3">
          <div class="form-group">
            <label class="form-label">II. félév</label>
            <input disabled="disabled" type="text" name="tanulm_mf" class="form-control" v-model="form.hallgato_atlagok.felev2"/>
          </div>
        </div>
        <div class="col-xs-3">
          <div class="form-group">
            <label class="form-label">Átlag</label>
            <input disabled="disabled" type="text" name="tanulm_atlag" class="form-control" v-model="form.hallgato_atlagok.atlag"/>
          </div>
        </div>
        <div class="col-xs-12">
          <h6>Nyelvvizsgák</h6>
          <div class="info-box warning">
            Kizárólag a Neptun rendszerben a Tanulmányi Ügyintéző által rögzített nyelvvizsgá(k)oz van lehetőség mellékletként a bizonyítvány másolatának feltöltésére.
          </div>
          <div class="row">
            <div class="col-xs-12">
              <UploadHandlerWithComboAddRemove :hide_point="true" ref="nyelvtudas" :key="getFieldByName('nyelvtudas').name" :block_once="true" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'nyelvtudas'); }" :accepted_files="getFieldByName('nyelvtudas').accepted_files" :options="getFieldByName('nyelvtudas').options" :id="getFieldByName('nyelvtudas').name" :label="getFieldByName('nyelvtudas').label" :name="getFieldByName('nyelvtudas').name"/>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <h5 class="form-block-title">
            Kutatás
          </h5>
        </div>

        <div class="col-xs-12">
          <inputbox :errors="errors" id="kutatasi_tema_cime" label="Kutatási téma címe" name="kutatasi_tema_cime" v-model="form.values.kutatasi_tema_cime"/>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <label class="form-label">Kutatása kapcsolódik a megjelölt témához/témákhoz</label>
            <div class="form-checkbox-wrapper" v-for="(option, i) in getFieldByName('temak').options">
              <input :id="'temak_'+i" :name="'temak_'+i" type="checkbox" :value="option.value" v-model="form.values.temak"/>
              <label :for="'temak_'+i">
                <div class="icon"></div>
                {{ option.text }}
              </label>
            </div>
            <div v-if="error.id == 'temak'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>

        <div class="col-xs-12">
          <textareabox maxlength="4000" tooltipDescription="Motivációs levél (karakterszám szóközzel együtt min 2000 - max 4000) - mely részletezi a pályázó jövőbeli szakmai terveit, valamint indokolja, hogy a kutatási témája miként is kapcsolódik a fent meghatározott témakörhöz/témakörökhöz" :autogrow="true" :errors="errors" id="motivacios_level" label="Motivációs levél" name="motivacios_level" v-model="form.values.motivacios_level"/>
        </div>

        <div class="col-xs-12">
          <h5 class="form-block-title">
            Mellékletek
          </h5>
        </div>

        <div class="col-xs-12">
          <UploadHandlerWithComboAddRemove tooltipDescription="Az összes melléklethez kötelező fájlt csatolni" :hide_point="true" ref="mellekletek" :key="getFieldByName('mellekletek').name" :block_once="true" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'mellekletek'); }" :accepted_files="getFieldByName('mellekletek').accepted_files" :options="getFieldByName('mellekletek').options" :id="getFieldByName('mellekletek').name" :label="getFieldByName('mellekletek').label" :name="getFieldByName('mellekletek').name"/>
        </div>

        <div v-if="doktorandusz()" class="col-xs-12">
          <UploadHandlerWithComboAddRemove tooltipDescription="Tételes lista a pályázat benyújtásának időpontjáig megjelent publikációkról: MTMT-ből nyomtatott teljes lista a presztízs és szponzor adatok jelölésével, valamint az MTMT Közlemény és idéző összefoglaló táblázat" :hide_point="true" ref="megjelent_publikaciok_mtmt_lista_alapjan" :key="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'megjelent_publikaciok_mtmt_lista_alapjan'); }" :accepted_files="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').accepted_files" :options="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').options" :id="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name" :label="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').label" :name="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name"/>
        </div>

        <div class="col-xs-12">
          <h5 class="form-block-title">
            Opcionális
          </h5>
        </div>

        <div class="col-xs-12">
          <UploadHandlerWithComboAddRemove :hide_point="true" :enable_block_delete="false" :hide_all_options="true" ref="otdk" :key="getFieldByName('otdk').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'otdk'); }" :accepted_files="getFieldByName('otdk').accepted_files" :options="getFieldByName('otdk').options" :id="getFieldByName('otdk').name" :label="getFieldByName('otdk').label" :name="getFieldByName('otdk').name"/>
        </div>

        <div class="col-xs-12">
          <UploadHandlerWithComboAddRemove :hide_point="true" :enable_block_delete="false" :hide_all_options="true" ref="hazi_tmdk" :key="getFieldByName('hazi_tmdk').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'hazi_tmdk'); }" :accepted_files="getFieldByName('hazi_tmdk').accepted_files" :options="getFieldByName('hazi_tmdk').options" :id="getFieldByName('hazi_tmdk').name" :label="getFieldByName('hazi_tmdk').label" :name="getFieldByName('hazi_tmdk').name"/>
        </div>

        <div class="col-xs-12">
          <UploadHandlerWithComboAddRemove :hide_point="true" ref="egyeb_szakmai_tanulmanyi_versenyek" :key="getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'egyeb_szakmai_tanulmanyi_versenyek'); }" :accepted_files="getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').accepted_files" :options="getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').options" :id="getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').name" :label="getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').label" :name="getFieldByName('egyeb_szakmai_tanulmanyi_versenyek').name"/>
        </div>

        <div class="col-xs-12">
          <UploadHandlerWithComboAddRemove :hide_point="true" ref="egyeb_kiemelkedo_szakmai_tevekenyseg" :key="getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'egyeb_kiemelkedo_szakmai_tevekenyseg'); }" :accepted_files="getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').accepted_files" :options="getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').options" :id="getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').name" :label="getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').label" :name="getFieldByName('egyeb_kiemelkedo_szakmai_tevekenyseg').name"/>
        </div>

        <div class="col-xs-12">
          <UploadHandlerWithComboAddRemove :hide_point="true" ref="egyeb_szakmai_tevekenyseg" :key="getFieldByName('egyeb_szakmai_tevekenyseg').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'egyeb_szakmai_tevekenyseg'); }" :accepted_files="getFieldByName('egyeb_szakmai_tevekenyseg').accepted_files" :options="getFieldByName('egyeb_szakmai_tevekenyseg').options" :id="getFieldByName('egyeb_szakmai_tevekenyseg').name" :label="getFieldByName('egyeb_szakmai_tevekenyseg').label" :name="getFieldByName('egyeb_szakmai_tevekenyseg').name"/>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <label class="form-label">Jelen projekt keretében már részesült ösztöndíjban</label>
            <div class="form-checkbox-wrapper">
              <input id="reszesult_osztondijban" name="reszesult_osztondijban" type="checkbox" value="1" v-model="form.values.reszesult_osztondijban"/>
              <label for="reszesult_osztondijban">
                <div class="icon"></div>
              </label>
            </div>
          </div>
        </div>

        <div v-show="form.values.reszesult_osztondijban" class="col-xs-12">
          <UploadHandlerWithComboAddRemove :hide_point="true" ref="reszesult_osztondijban_mtmt" :key="getFieldByName('reszesult_osztondijban_mtmt').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'reszesult_osztondijban_mtmt'); }" :accepted_files="getFieldByName('reszesult_osztondijban_mtmt').accepted_files" :options="getFieldByName('reszesult_osztondijban_mtmt').options" :id="getFieldByName('reszesult_osztondijban_mtmt').name" :label="getFieldByName('reszesult_osztondijban_mtmt').label" :name="getFieldByName('reszesult_osztondijban_mtmt').name"/>
        </div>

        <div v-if="!doktorandusz()" class="col-xs-12">
          <UploadHandlerWithComboAddRemove tooltipDescription="Tételes lista a pályázat benyújtásának időpontjáig megjelent publikációkról: MTMT-ből nyomtatott teljes lista a presztízs és szponzor adatok jelölésével, valamint az MTMT Közlemény és idéző összefoglaló táblázat" :hide_point="true" ref="megjelent_publikaciok_mtmt_lista_alapjan" :key="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name" :errors="errors" max_uploaded_files="5" v-on:change="(value) => { changeValue(value, 'megjelent_publikaciok_mtmt_lista_alapjan'); }" :accepted_files="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').accepted_files" :options="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').options" :id="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name" :label="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').label" :name="getFieldByName('megjelent_publikaciok_mtmt_lista_alapjan').name"/>
        </div>

        <div class="col-xs-12">
          <h5 class="form-block-title">
            Adatvédelem
          </h5>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <label class="form-label">Adatvédelmi nyilatkozat</label>
            <div class="form-scroll-block">A jelentkezési lapon szereplő személyes adatok kezelése az érintett önkéntes hozzájárulásán alapul, mely hozzájárulást az érintett a pályázati adatlap kitöltésével és annak aláírásával ad meg.<br><br>Az adatkezelők harmadik személy(ek) részére adattovábbítást nem végeznek.<br><br>Az érintett hozzájárulása indokolás nélkül bármikor visszavonható.<br><br>A kezelt adatokba betekintést kizárólag az adatkezelők ösztöndíj elnyerésére való jogosultság megállapításával, annak elbírálásával, valamint az ösztöndíj folyósításával összefüggő feladatokat ellátó munkatársa(i) nyerhet(nek) a fenti feladatok ellátásához szükséges ideig és mértékben. A jelentkezési lapon szereplő adatok a jelentkezés sikertelensége esetén az elbírálást követő 1 hónapig kezelhetőek.<br><br>Pozitív elbírálás esetén a Széchenyi István Egyetem az EFOP-3.6.1-16-2016-00017 / EFOP-3.6.3-VEKOP-16-2017-00008 pályázat keretében az ösztöndíjas hallgatóról megismert személyes adatokat az ösztöndíjszerződés lejáratát követő 8 évig jogosult kezelni.<br><br>Az érintett az adatkezelés teljes időtartama alatt élhet az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvényben biztosított jogával, (tájékoztatáshoz, helyesbítéshez, törléshez, zároláshoz, tiltakozáshoz való jog) továbbá jogsérelem esetén bírósághoz, valamint a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (1125 Budapest, Szilágyi Erzsébet fasor 22/c., tel.: 06-1-391-1400, honlap URL címe: http://naih.hu, elektronikus levelezési cím: ugyfelszolgalat@naih.hu ) is fordulhat.</div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <div class="form-checkbox-wrapper">
              <input id="adatvedelem" name="adatvedelem" type="checkbox" value="1" v-model="form.values.adatvedelem"/>
              <label for="adatvedelem">
                <div class="icon"></div>
                Adatvédelmi nyilatkozat elfogadása
              </label>
            </div>
            <div v-if="error.id == 'adatvedelem'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <label class="form-label">Nyilatkozat</label>
            <div class="form-scroll-block">A pályázat beadásával büntetőjogi felelősségem tudatában kijelentem, hogy az általam közölt adatok a valóságnak megfelelnek, és ellenőriztem, hogy minden adatom helyesen szerepel a Neptun Hallgatói Információs Rendszerben. Különös tekintettel a pályázathoz szükséges adatokra (név, születési hely és idő, édesanyja neve, taj szám, számlaszám, adószám, állandó lakcím).<br><br>Tudomásul veszem, hogy valótlan adatok megadása az ösztöndíj programból történő kizárást eredményezi.<br><br>Nyilatkozom, hogy a pályázati felhívást megismertem, az abban foglaltakat tudomásul vettem és a pályázat elnyerése esetén magamra kötelezőnek ismerem el.<br><br>Az adatvédelmi tájékoztató ismeretében hozzájárulok, hogy a fent megadott személyes adataimat a Széchenyi István Egyetem az EFOP-3.6.1-16-2016-00017 / EFOP-3.6.3-VEKOP-16-2017-00008 pályázattal összefüggésben személyes kezelje.</div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <div class="form-checkbox-wrapper">
              <input id="nyilatkozat" name="nyilatkozat" type="checkbox" value="1" v-model="form.values.nyilatkozat"/>
              <label for="nyilatkozat">
                <div class="icon"></div>
                Nyilatkozat elfogadása
              </label>
            </div>
            <div v-if="error.id == 'nyilatkozat'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button :disabled="!save_enabled" v-on:click="save(0)" type="button" name="ment" class="button">Mentés</button>
            <button :disabled="!save_enabled" v-on:click="save(1)" type="button" name="kuld" class="button">Véglegesít</button>
          </div>
        </div>

      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-title">{{ form.name }}</div>
          <div class="article-text" v-html="fill_info"></div>
          <div v-if="remedy">
            <div style="margin-top: 30px;" class="info-box warning">
              Figyelem! Az elbírálással kapcsolatban fellebezést nyújthat be.
            </div>
            <a href="javascript:void(0)" title="" v-on:click="remedy_popup = true;" class="button">Fellebezés</a>
          </div>

          <div style="margin-top: 40px;" class="info-box" v-if="remedy_user != false">
            <div class="title">Fellebezés</div>
            <div><span class="highlight">{{ remedy_user.name }}</span> ({{remedy_user.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_user.msg)">
            </div>
          </div>

          <div style="margin-top: 20px;" class="info-box" v-if="remedy_admin != false">
            <div class="title">Fellebezés válasz</div>
            <div><span class="highlight">{{ remedy_admin.name }}</span> ({{remedy_admin.created}})</div>
            <div style="padding-top: 20px;" v-html="$root.nl2br(remedy_admin.msg)">
            </div>
          </div>

        </div>
      </div>
    </div>
    <Fellebezes v-on:close="(final) => { remedy_popup = false; if (final) remedy = false; }" v-if="remedy && $route.query.id != undefined && remedy_popup" :form_id="$route.query.id"/>
  </div>
</template>

<script>
import Vue from 'vue';
import Fellebezes from './fellebezes.vue';

export default {
  components: {
    Fellebezes
  },
  data: function() {
    return {
      save_enabled: false,
      fill_info: '',
      pdf_filename: '',
      errors: [],
      fields_normal: [],
      fields_doktorandusz: [],
      nyelvtudas: [],
      remedy: false,
      remedy_popup: false,
      remedy_admin: false,
      remedy_user: false,
      form: {
        name: '',
        fields: [],
        values: {
          adatvedelem: false,
          nyilatkozat: false
        },
        hallgato_alapadatok: {},
        hallgato_atlagok: {},
        prev_academic_year: ''
      },
      hallgato_alapadatok_t: [],
      hallgato_atlagok_t: [],
      szak_combo_opts: [],
      szak_combo_index: 0
    }
  },

  computed: {
    elozo_tanev: function() {
      if(this.form.prev_academic_year) {
        return '(' + this.form.prev_academic_year + ')';
      } else {
        return '';
      }
    }
  },

  watch: {
    'form.values.reszesult_osztondijban': function() {
      if (this.form.values.reszesult_osztondijban == false && this.$refs['reszesult_osztondijban_mtmt'] != undefined) {
        this.$refs['reszesult_osztondijban_mtmt'].reset();
      }
    }
  },

  mounted: function() {
  	var _this = this;
    this.form.id = this.$route.query.id;

    this.$root.ajax('form/utanpotlas_hallgatoi_osztondij_kitoltes_ellenorzes/' + this.$route.query.id, {
      success: function(response) {
        if (response.error) {
          swal('Hiba!', response.error, 'error');

        } else {
          if (response.redirect_path == undefined) {
            response.form_fields.map(function(ff) {
              if (ff.type == 'UploadHandlerWithComboAddRemove') {
                ff.options.map(function(opt) {
                  opt.show = 1;
                });
                Vue.set(_this.form.values, ff.name, []);
              }

              if (ff.type == 'Checkboxes') {
                Vue.set(_this.form.values, ff.name, []);
              }

              if (ff.type == 'Inputbox') {
                Vue.set(_this.form.values, ff.name, '');
              }

              if (ff.type == 'Checkbox') {
                Vue.set(_this.form.values, ff.name, false);
              }

              if (ff.type == 'Textareabox') {
                Vue.set(_this.form.values, ff.name, '');
              }
            });

            _this.form.fields = response.form_fields;
            _this.nyelvtudas = response.nyelvtudas;
            _this.remedy = response.remedy;

            if (response.remedy_admin != undefined)
              _this.remedy_admin = response.remedy_admin;

            if (response.remedy_user != undefined)
              _this.remedy_user = response.remedy_user;

            _this.form.hallgato_alapadatok = response.hallgato_alapadatok;
            _this.form.hallgato_atlagok = response.hallgato_atlagok;
            _this.hallgato_alapadatok_t = response.hallgato_alapadatok_t;
            _this.hallgato_atlagok_t = response.hallgato_atlagok_t;
            _this.fields_normal = response.form_fields_normal;
            _this.fields_doktorandusz = response.form_fields_doktorandusz;

            // Szak választó combó adatok a hallgató alapadatok tömbből
            _this.hallgato_alapadatok_t.map(function(h, i) {
              _this.szak_combo_opts.push({
                value: i,
                label: h.szak + ' ' + h.kepzes_szint + ' (' + h.tagozat + ')'
              });
            });

            _this.form.fields.map(function(field) {
              if(field.name == 'nyelvtudas') {
                field.options = field.options.concat(response.nyelvtudas);
              }
            });

            _this.form.name = response.form_name;
            _this.form.academic_year = response.academic_year;
            _this.fill_info = response.fill_info;

            // TMDK, OTDK lekérdezése, akkor ha nincs mentett adat
            if (response.saved_data == undefined) {
              Vue.nextTick(function() {
                _this.tmdkLekerdezese();
                _this.otdkLekerdezese();
              });
            }

            setTimeout(function() {
              // Korábbi mentés visszatöltése
              if (response.saved_data != undefined && response.saved_data != '') {
                // Kiválasztott szakkódot visszaállítja
                _this.hallgato_alapadatok_t.map(function(item, i) {
                  if (item.szakkod == response.saved_data.szakkod) {
                    _this.szak_combo_index = i;
                    _this.szakValt(i, false, false);
                  }
                });

                // Űrlap adatok visszatöltése
                _this.form.values = response.saved_data.values;

                // UploadHandlerWithComboAddRemove blokkok visszatöltése
                response.saved_data.upload_blocks.map(function(upload_block) {
                  Vue.nextTick(function() {
                    if (_this.$refs[upload_block.id] != undefined) {
                      _this.$refs[upload_block.id].removeAllBlock(); // Ne legyen duplikált blokk, ha az automatikus combó állításnál egyszer már be lett állítva
                      _this.$refs[upload_block.id].setBlocks(upload_block.blocks);

                      // TMDK
                      if (upload_block.id == "hazi_tmdk" && upload_block.blocks.length == 0) {
                        _this.$refs["hazi_tmdk"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                      }

                      // OTDK
                      if (upload_block.id == "otdk" && upload_block.blocks.length == 0) {
                        _this.$refs["otdk"].setNoOptionMsg('Nyilvántartásban nem szerepel.');
                      }
                    }
                  });
                });
              }
            }, 10);

            if (response.hallgato_alapadatok && response.hallgato_atlagok) {
              _this.save_enabled = true;

            } else {
              swal('Hiba!','Hiányos hallgatói adatok.','error');
            }

          } else {
            _this.$router.push({path: response.redirect_path});
          }
        }
      }
    });
  },
  methods: {
    tmdkLekerdezese: function() {
      var _this = this;

      // Kiválasztott szak alapján lekérdezi a tmdk-at
      this.$root.ajax('hallgato_tmdk/', {
        method: 'POST',
        data: {
          szakkod: this.hallgato_alapadatok_t[this.szak_combo_index].szakkod
        },
        success: function(response) {
          if (response.error) {
            alert(response.error);

          } else {
            if (_this.$refs['hazi_tmdk'] == undefined)
              return;

            // Kiválasztott szak aktív félévének száma
            var aktiv_felevek_szama = _this.hallgato_alapadatok_t[_this.szak_combo_index].aktiv_felevek_szama;

            // tmdk blokk resetelése
            _this.$refs['hazi_tmdk'].reset();

            var has_tmdk = false;

            _this.form.fields.map(function(field) {
              if (field.name == 'hazi_tmdk') {
                field.options.map(function(opt) {
                  opt.show = 0;

                  response.tmdks.map(function(tmdk) {
                    // Lekeresi a helyezés alapján a combó value-t, és hozzáad egy új blokkot
                    if (opt.text == tmdk.helyezes) {
                      // Csak a tárgyfélévben vagy az azt megelőző félévben végzett, megfelelően igazolt, szakmai tevékenység esetén
                      //if (aktiv_felevek_szama == tmdk.aktiv_felevek_szama || (aktiv_felevek_szama - 1) == tmdk.aktiv_felevek_szama || (aktiv_felevek_szama - 2) == tmdk.aktiv_felevek_szama) {
                        _this.$refs['hazi_tmdk'].changeComboValue(opt.value);
                        _this.$refs['hazi_tmdk'].addBlock();
                        has_tmdk = true;
                      //}
                    }
                  });
                });
              }
            });

            if (!has_tmdk)
              _this.$refs['hazi_tmdk'].setNoOptionMsg('Nyilvántartásban nem szerepel.');
            else
              _this.$refs['hazi_tmdk'].clearNoOptionMsg();

          }
        }
      });
    },

    otdkLekerdezese: function() {
      var _this = this;

      // Kiválasztott szak alapján lekérdezi az otdk-at
      this.$root.ajax('hallgato_otdk/', {
        method: 'POST',
        data: {
          szakkod: this.hallgato_alapadatok_t[this.szak_combo_index].szakkod
        },
        success: function(response) {
          if (response.error) {
            alert(response.error);

          } else {
            if (_this.$refs['otdk'] == undefined)
              return;

            // Kiválasztott szak aktív félévének száma
            var aktiv_felevek_szama = _this.hallgato_alapadatok_t[_this.szak_combo_index].aktiv_felevek_szama;

            // otdk blokk resetelése
            _this.$refs['otdk'].reset();

            var has_otdk = false;

            _this.form.fields.map(function(field) {
              if (field.name == 'otdk') {
                field.options.map(function(opt) {
                  opt.show = 0;

                  response.otdks.map(function(otdk) {
                    // Lekeresi a helyezés alapján a combó value-t, és hozzáad egy új blokkot
                    if (opt.text == otdk.helyezes) {
                      // Csak a tárgyfélévben vagy az azt megelőző félévben végzett, megfelelően igazolt, szakmai tevékenység esetén
                      //if (aktiv_felevek_szama == otdk.aktiv_felevek_szama || (aktiv_felevek_szama - 1) == otdk.aktiv_felevek_szama || (aktiv_felevek_szama - 2) == otdk.aktiv_felevek_szama) {
                        _this.$refs['otdk'].changeComboValue(opt.value);
                        _this.$refs['otdk'].addBlock();
                        has_otdk = true;
                      //}
                    }
                  });
                });
              }
            });

            if (!has_otdk)
              _this.$refs['otdk'].setNoOptionMsg('Nyilvántartásban nem szerepel.');
            else
              _this.$refs['otdk'].clearNoOptionMsg();

          }
        }
      });
    },

    save: function(bekuld) {
      var _this = this;

      // elmenti az UploadHandlerWithComboAddRemove blokkok struktúráját
      var upload_blocks = [];
      ['nyelvtudas','mellekletek','otdk','hazi_tmdk','egyeb_szakmai_tanulmanyi_versenyek','egyeb_kiemelkedo_szakmai_tevekenyseg','egyeb_szakmai_tevekenyseg','megjelent_publikaciok_mtmt_lista_alapjan','reszesult_osztondijban_mtmt'].map(function(id) {
        if (_this.$refs[id] != undefined) {
          upload_blocks.push({id: id, blocks: _this.$refs[id].getBlocksToSave()});
        }
      });
      this.form.upload_blocks = upload_blocks;

      this.$root.ajax('form/utanpotlas_hallgatoi_osztondij_kitoltes_mentes/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          bekuld: bekuld
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = response.fill_info;
          }
        }
      });
    },

    changeValue: function(value, name) {
      this.form.values[name] = value;
    },

    getFieldByName: function(field_name) {
      var f;
      this.form.fields.map(function(field) {
        if (field.name == field_name)
          f = field;
      });
      return f;
    },

    doktorandusz: function() {
      return [73004, 73012, 73009].indexOf(parseInt(this.form.hallgato_alapadatok.kepzes_szint_id)) > -1 ? true : false;
    },

    szakValt: function(index, tmdk_beallitas, otdk_beallitas) {
      var _this = this;

      // Dokumentum feltöltők reset-elése
      this.form.fields.map(function(f) {
        if (_this.$refs[f.name] != undefined)
          _this.$refs[f.name].reset();
      });

      // Hallgató adatok frissítése
      this.form.hallgato_alapadatok = this.hallgato_alapadatok_t[index];
      this.form.hallgato_atlagok = this.hallgato_atlagok_t[index];

      // Beállítja a mezőket
      if (this.doktorandusz()) {
        this.form.fields = JSON.parse(JSON.stringify(this.fields_doktorandusz));
      } else {
        this.form.fields = JSON.parse(JSON.stringify(this.fields_normal));
      }

      // Kitörli az értékeket
      this.form.values = {
        adatvedelem: false,
        nyilatkozat: false
      }

      this.form.fields.map(function(ff) {
        if (ff.type == 'UploadHandlerWithComboAddRemove') {
          if (ff.name != 'otdk' && ff.name != 'hazi_tmdk')
            ff.options.map(function(opt) {
              opt.show = 1;
            });

          Vue.set(_this.form.values, ff.name, []);
        }

        if (ff.type == 'Checkboxes') {
          Vue.set(_this.form.values, ff.name, []);
        }

        if (ff.type == 'Inputbox') {
          Vue.set(_this.form.values, ff.name, '');
        }

        if (ff.type == 'Textareabox') {
          Vue.set(_this.form.values, ff.name, '');
        }

        if (ff.type == 'Checkbox') {
          Vue.set(_this.form.values, ff.name, false);
        }
      });

      this.form.fields.map(function(field) {
        if (field.name == 'nyelvtudas') {
          field.options = field.options.concat(_this.nyelvtudas);
        }
      });

      if (tmdk_beallitas) {
        this.tmdkLekerdezese();
      }

      if (otdk_beallitas) {
        this.otdkLekerdezese();
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// utanpotlas_hallgatoi_osztondij.vue?6c499f81